import { defineComponent as _defineComponent } from 'vue'
import router from "../router";
import events from "../events";
import { onMounted, ref, watch, computed} from "vue";
import NavBar from '../components/navbar.vue';
import Feedback from '../components/feedback.vue';
import hamburger from '../components/hamburger-icon.vue'
import { checkLoggedIn } from "../util/auth";
import debounce from "lodash/debounce"

import useClickOutside from '../composables/useClickOutside'
import { useUserspace } from "@/store/userspace";


export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props, { expose }) {
  expose();

const useNavbar   = ref(false);
const showFeedback = ref(false);
const useCardBase = ref(false);
const isMobile    = ref(false);
const showMenu = ref(false);
const showSetup = ref(false)


router.beforeEach(to => {
    //Pages to exclude the .card-base class
    /// - We have to.meta for this
    const excludeCardOn = [  "landing", "auth-new", "auth", "setup", "offer", "preview" ].some(el => to.path.includes(el));
    const excludeNavOn = [  "landing", "auth-new", "auth", "setup"].some(el => to.path.includes(el));
    // Don't show cardBase if page is fullscreen
    useCardBase.value = !(to?.meta?.useFullscreen && excludeCardOn);
    // Don't show NavBar on any page which excludes card-base
    useNavbar.value = !excludeNavOn;
})

const handleSize = (width: number, height: number) => {
    if(width < 500) {
        isMobile.value = true;
    } else {
        isMobile.value = false;
    }
}
onMounted(() => {
    window.APPLICATION_LOADER.done();
    handleSize(window.innerWidth, window.innerHeight);
    window.addEventListener("resize", () => {
        handleSize(window.innerWidth, window.innerHeight);
    })
})

const menu = ref()
useClickOutside(menu, ()=> {
    if(showMenu.value)
        showMenu.value = false
})


const checkSetup = computed(() =>{
    let isLoggedIn = checkLoggedIn()
    if(isLoggedIn){
        let userspace = useUserspace().user;
        console.log(userspace.setupCompleted)
        if (userspace.setupCompleted.length < 3){
            return true
        }else{
            return false
        }
    }
    return false
})

const documentHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
}
window.addEventListener(`resize`, debounce(documentHeight, 50))
documentHeight()




const __returned__ = { useNavbar, showFeedback, useCardBase, isMobile, showMenu, showSetup, handleSize, menu, checkSetup, documentHeight, router, events, onMounted, ref, watch, computed, NavBar, Feedback, hamburger, checkLoggedIn, debounce, useClickOutside, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})